import React from 'react';
import type { WeatherIconKind } from '../../domain/Weather';

interface Props {
  icon: WeatherIconKind | 'wind' | 'thermometer';
  size?: number;
}

const WeatherIcon: React.FC<Props> = ({ icon, size = 20 }) => {
  const common = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.75,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
  };

  if (icon === 'sun') {
    return (
      <svg {...common}>
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2.5v2.5M12 19v2.5M4.2 12H1.7M22.3 12h-2.5M6 6l1.8 1.8M16.2 16.2 18 18M18 6l-1.8 1.8M6 18l1.8-1.8" />
      </svg>
    );
  }

  if (icon === 'rain') {
    return (
      <svg {...common}>
        <path d="M18 10.5A5 5 0 0 0 9 7.3 4 4 0 0 0 8 15h9.5a3.5 3.5 0 0 0 .5-4.5Z" />
        <path d="M8 19l1-1.5M12 19l1-1.5M16 19l1-1.5" />
      </svg>
    );
  }

  if (icon === 'wind') {
    return (
      <svg {...common}>
        <path d="M3 8h11a2.5 2.5 0 1 0-2.5-2.5" />
        <path d="M3 12.5h15a2.5 2.5 0 1 1-2.5 2.5" />
        <path d="M3 17h8a2 2 0 1 1-2 2" />
      </svg>
    );
  }

  if (icon === 'thermometer') {
    return (
      <svg {...common}>
        <path d="M12 14.5V5a2 2 0 1 0-4 0v9.5a4 4 0 1 0 4 0Z" />
      </svg>
    );
  }

  return (
    <svg {...common}>
      <path d="M7 18a4 4 0 0 1-.6-7.96 5 5 0 0 1 9.4-2A4.5 4.5 0 0 1 17 18H7Z" />
    </svg>
  );
};

export default WeatherIcon;
